import { Component, OnInit } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { ActivatedRoute, Router } from '@angular/router';
import { TransactionService } from 'src/app/services/transaction.service';
import { MetatagService } from 'src/app/services/metatag.service';
import { MatDialog } from '@angular/material/dialog';
import { HowBuyComponent } from 'src/app/elements/dialog-questions/how-buy/how-buy.component';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss'],
  animations: [
    trigger(
      'stepsAnimation', [
        transition(
          ':enter',[
            style({
              opacity: 0
            }),
            animate('0.3s ease', style({
              opacity: 1
            }))
          ]
        )
      ]
    )
  ]
})
export class CheckoutComponent implements OnInit {

  step = 1;

  onlyShowSectionThree:boolean = true;

  constructor(
    protected transactionService: TransactionService,
    protected navigator: Router,
    protected metatagService: MetatagService,
    protected route: ActivatedRoute,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.metatagService.configSlug('checkout');
    this.verifyState();
  }

  clickBackOne() {
    this.step = 1;
  }

  clickStepOneContinue() {
    this.step = 2;
  }

  clickStepFiveContinue() {
    this.step = 5;
  }

  sectionActive = 0;
  
  clickSection(section) {
    this.step = section;
  }

  verifyTransaction() {
    if (this.transactionService.transactionCurrent == undefined) {
      this.navigator.navigateByUrl('/');
    }
  }

  verifyState() {
    this.route.data.subscribe(params => {
      if (params.step) {
        this.step = params.step;
      } else {
        this.verifyTransaction();
      }
    });
  }

  onOpenHelp(): void {
    const dialogRef = this.dialog.open(HowBuyComponent, {
      width: '1000px',
      panelClass: 'modal-help-center'
    });
  }
}
